import { Skeleton } from 'components/widgets/skeleton';

export default function SkeletonText() {
  return (
    <Skeleton
      css={{ height: 16, width: 50, marginRight: 4, '@md': { width: 80 } }}
    />
  );
}
